export default __webpack_public_path__ + "static/media/notfound.1927d285.gif";